export default [
    {
        title: 'Dashboard',
        to: {name: 'index'},
        icon: {icon: 'mdi mdi-view-dashboard'},
    },
    {
        title: 'New Order',
        to: {name: 'order-type'},
        icon: {icon: 'mdi mdi-plus-circle'},
    },
    {
        title: 'Orders',
        to: {name: 'orders'},
        icon: {icon: 'mdi mdi-receipt-text'},
    },
    {
        title: 'Tables',
        to: {name: 'tables'},
        icon: {icon: 'mdi mdi-table-furniture'},
    },
    {
        title: 'Bookings',
        to: {name: 'reservations'},
        icon: {icon: 'mdi mdi-calendar-clock'},
    },
    {
        title: 'Reports',
        to: {name: 'reports'},
        icon: {icon: 'mdi mdi-chart-box'},
    },
    {
        title: 'Staff',
        to: {name: 'staff'},
        icon: {icon: 'mdi mdi-account-multiple'},
    },
    {
        title: 'Customers',
        to: {name: 'customers'},
        icon: {icon: 'mdi mdi-account-heart'},
    },
    {
        title: 'Settings',
        to: {name: 'settings'},
        icon: {icon: 'mdi mdi-cog'},
    },
    {
        title: 'Devices',
        to: {name: 'devices'},
        icon: {icon: 'mdi mdi-devices'},
    },
    {
        title: 'KDS',
        to: {name: 'kds'},
        icon: {icon: 'mdi mdi-chef-hat'},
    },
]
